import { posthogCapture } from '../../../lib/logging/posthog.js'

export function setKindeSession(kindeToken) {
  localStorage.setItem('kindeToken', JSON.stringify(kindeToken))
}

export function clearAuthSession() {
  localStorage.removeItem('kindeToken')
  localStorage.removeItem('auth-storage')
}

/**
 * Remove every local token artifact, including the SDK's chunked refresh
 * token. Unlike clearAuthSession(), this leaves nothing behind that could
 * silently resurrect the session (the SDK persists refreshToken0..N during
 * the code exchange, before the app validates the token). Never touches the
 * Kinde SSO session.
 */
export function clearLocalTokens() {
  clearAuthSession()

  // The Kinde SDK chunks long refresh tokens across refreshToken0..N
  for (let i = 0; localStorage.getItem(`refreshToken${i}`) !== null; i++) {
    localStorage.removeItem(`refreshToken${i}`)
  }
}

/**
 * Tear down the local session WITHOUT touching the Kinde SSO session.
 *
 * Automatic failure paths (dead refresh token, backend TOKEN_DATA_ERROR,
 * bootstrap failures) must use this instead of authBridge.logout(): a Kinde
 * /logout revokes the SSO session, the shared refresh token, and live
 * validation of every outstanding access token — which logs out every other
 * tab and the legacy app. Only the user's explicit logout may do that.
 *
 * Removes all local token artifacts and redirects to /login. The redirect is
 * skipped on the login page itself, where public requests (tenant config)
 * also flow through apiClient — without the guard a dead token would reload
 * /login in a loop.
 */
export function teardownLocalSession(reason) {
  const hadSession =
    localStorage.getItem('kindeToken') !== null ||
    localStorage.getItem('refreshToken0') !== null ||
    localStorage.getItem('auth-storage') !== null

  clearLocalTokens()

  // A burst of concurrently failing requests triggers teardown once — later
  // calls find the storage already empty and stay silent
  if (hadSession) {
    posthogCapture('auth_teardown', { reason })
  }

  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = '/login'
  }
}
